export const APIConfig = {
  tokenKey: 'user-token',
};

export default {
  APIConfig,
};
